import type { Item, PrefectureItem } from '~/types/master-data';

export interface MapAreaItem extends Item {
  children?: PrefectureItem[];
}

/**
 * areas データに children を追加して prefectures を紐づける
 * @param areas - エリアデータ
 * @param prefectures - 都道府県データ
 * @returns children に都道府県が追加されたエリアデータ
 */
export function mapAreaPrefectures(
  areas: MapAreaItem[],
  prefectures: PrefectureItem[],
): MapAreaItem[] {
  // エリアをマップで管理
  const areaMap = new Map<number, MapAreaItem>();

  // エリアをマップに格納
  areas.forEach((area) => {
    areaMap.set(area.id, { ...area, children: [] });
  });

  // 都道府県を対応するエリアの children に追加
  prefectures.forEach((prefecture) => {
    const area = areaMap.get(prefecture.area_id);
    if (area) {
      area.children?.push(prefecture);
    }
  });

  // エリアの配列に戻す
  return Array.from(areaMap.values());
}
